// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2Beo5","imageUploader":"EGiftCard_imageUploader__3OCZZ"};